

import React, { useState } from 'react';
import ProductDisplay from '../../components/ProductDisplay.js';
// import Carousel from '../components/Carousel';
import Carousel from '../../components/Carousel.js'
import CarouselComponent from '../../components/CarouselComponent.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronRight } from '@fortawesome/free-solid-svg-icons';
// import aop1 from 'product/aop.png'
// import FAQSection from '../components/FAQSection';
import tech1 from "../../assests/technology (1).png";
import tech2 from "../../assests/technology (2).png";
import tech3 from "../../assests/plasmOX.png";
function Gridmatrix() {
    const [openFAQ, setOpenFAQ] = useState(null);

    const faqs = [
        {
            id: 1,
            question: "Features",
            answer: {
                type: "iconText",
                iconContent: [
                    {
                        image: "../product/ultrasorb/Group 151.png",
                        additionalText: "Innovative monolithic grid matrix design with uniform parallel airflow channels."
                    },
                    {
                        image: "../product/ultrasorb/Group 155.png",
                        additionalText: "High adsorption and chemisorption efficiency for superior contaminant removal."
                    },
                    {
                        image: "../product/ultrasorb/Group 154.png",
                        additionalText: "Available with customized media formulations for specific contaminant challenges."
                    },
                    {
                        image: "../product/ultrasorb/Group 153.png",
                        additionalText: "Life Testable"
                    },
                ]
            }
        },
        {
            id: 2,
            question: "Benefits",
            answer: {
                type: "list",
                items: [
                    "High-efficiency removal of gaseous contaminants and odors",
                    "Low pressure drops for reduced energy consumption",
                    "Large active surface area for enhanced adsorption capacity",
                    "Uniform airflow distribution across the filter media",
                    "Long service life with optimized media utilization"
                ]
            }
        },
        {
            id: 3,
            question: "Protection From",
            answer: {
                type: "images",
                images: ["../product/ultrasorb/H2s.png", "../product/ultrasorb/Asset 14.png", "../product/ultrasorb/Asset 13.png", "../product/ultrasorb/Asset 12.png", "../product/ultrasorb/Asset 11.png", "../product/ultrasorb/Asset 10.png"],
                imagescontent: ["Hydrogen Sulphie", "Chlorine", "Formaldehyde",
                    "Ammonia ", "Sulphur Dioxide", "Nitrogen Oxides ",]

            }
        },
        {
            id: 4,
            question: "Application Area",
            answer: {
                type: "words",
                words: [
                    "Government", "Airport", "Offices", "Residential", "University",
                    "Hospitality", "Transportation", "Factories", "Railways",
                ]
            }
        }
    ];



    const product = {
        headingText: "For Gases Filtration",
        title: "gridmatriX® Filter",
        downloadFile: "https://ultrapureindia.in/pdf/ultrasorb%20chemical%20media.pdf",
        mainImage: 'new_assets/Gridmatrix.png',
        relativeImages: [
            "./Product/ultrasorb.png",
            "./Product/ultrasorb.png",
            "./Product/ultrasorb.png",
            "./Product/ultrasorb.png",
        ],
    };
    const toggleFAQ = (id) => {
        setOpenFAQ(openFAQ === id ? null : id);
    };

    return (
        <div className="overflow-x-hidden">
            <ProductDisplay
                headingText={product.headingText}
                title={product.title}
                downloadFile={product.downloadFile}
                mainImage={product.mainImage}
                relativeImages={product.relativeImages}
            />



            <div className="flex flex-col md:flex-row  p-4 md:p-8 rounded-lg">
                <div className="w-full md:w-1/2 mt-4 md:mt-0 md:ml-6 flex flex-col justify-center">
                    <p className="text-gray-700 p-8 text-justify">
                        The ultraSORB® Grid Matrix Filter is an advanced gas-phase filtration solution engineered for the efficient removal of gaseous contaminants while maintaining exceptionally low pressure drop. It is specifically designed to deliver high-performance air purification in applications where odor control and gas removal are critical.<br />
                        The ultraSORB® Grid Matrix Filter effectively removes a wide range of odor-causing compounds, volatile organic compounds (VOCs), toxic gases, and other airborne chemical contaminants. Its optimized airflow characteristics reduce energy consumption, extend filter life, and improve the overall performance of air purification systems.

                    </p>
                </div>
                <div className="w-full md:w-1/2 flex justify-evenly items-center">
                    <div className="w-1/2">
                        <img src={tech2} alt="plasma" className=" h-auto rounded-lg" />
                        {/* <h6 className="font-bold text-sm">nanoX® Technology</h6> */}
                    </div>

                    {/* <div className="w-1/2">
                        <img src={tech3} alt="plasma" className=" h-auto rounded-lg" />
                        <h6 className="font-bold w-full text-sm">plasmOX® Technology</h6>
                    </div> */}
                </div>
            </div>
            {/* faq */}
            <div className="mx-auto bg-white p-8 rounded-lg shadow-lg">
                {/* <h2 className="text-2xl font-bold mb-6">Frequently Asked Questions</h2> */}
                {faqs.map((faq) => (
                    <div key={faq.id} className="mb-4">
                        <button
                            className={`w-full text-left p-4 rounded-full flex justify-between items-center focus:outline-none transition-colors duration-300 ${openFAQ === faq.id
                                ? "bg-gradient-to-r from-textBlue to-ultragreen text-white"
                                : "bg-gray-200 text-black"
                                }`}
                            onClick={() => toggleFAQ(faq.id)}
                        >
                            <span className="text-lg">{faq.question}</span>
                            <FontAwesomeIcon
                                icon={openFAQ === faq.id ? faChevronDown : faChevronRight}
                            />
                        </button>
                        {openFAQ === faq.id && (
                            <div className="p-4 bg-gray-100 rounded-lg">
                                {faq.answer.type === "iconText" && (
                                    <div className="space-y-4 flex flex-wrap">
                                        {faq.answer.iconContent.map((content, index) => (
                                            <div key={index} className="flex sm:flex-wrap items-center w-full lg:w-1/4  p-3">
                                                {/* <img src={content.icon} alt="Icon" className="h-6 w-6 mr-2" />
                                                <span>{content.text}</span> */}
                                                <div className="flex items-center">
                                                    <img src={content.image} alt="Image" className="h-15 w-15 mx-2" />
                                                    <span>{content.additionalText}</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                                {faq.answer.type === "list" && (
                                    <ul className="list-disc list-inside">
                                        {faq.answer.items.map((item, index) => (
                                            <li key={index}>{item}</li>
                                        ))}
                                    </ul>
                                )}
                                {faq.answer.type === "images" && (
                                    <div className="grid grid-cols-3 sm:grid-cols-3 lg:grid-cols-6 gap-4">
                                        {faq.answer.images.map((image, index) => (
                                            <div key={index} className="text-center">
                                                <img src={image} alt={`Image ${index + 1}`} className=" mx-auto" />
                                                <span className="block mt-2">{faq.answer.imagescontent[index]}</span>
                                            </div>
                                        ))}
                                    </div>
                                )}
                                {faq.answer.type === "words" && (
                                    <div className="grid grid-cols-2 sm:grid-cols-1 lg:grid-cols-5 ml-5 ">
                                        {faq.answer.words.map((word, index) => (
                                            <li key={index}>{word}</li>
                                        ))}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                ))}
            </div>

            {/* product carousel */}
            {/* <Carousel /> */}
            {/* client tested carousel	 */}
            <CarouselComponent />
        </div>
    );
}

export default Gridmatrix;
